
module fdm.performedLegs {

    export class SyncPerformedLegsCommandController {
        public form: any;
        public command: any;
        private lookupResultQuery: any;
        public loadingAutoMatch: boolean = false;

        constructor(
            public $scope: any,
            private restfullApiClientService: dg.restfulApi.RestfullApiClientService,
            private actionService: dg.actions.ActionService
        ) {

        }

    }

    angular.module('fdm.performedLegs').component('syncPerformedLegsCommand', {
        bindings: {
            command: '<',
            form: '<'
        },
        controller: SyncPerformedLegsCommandController,
        templateUrl: '/app/src/performed-legs/sync-performed-legs-command.html'
    });
}
